import React from 'react';

import ActiveSuppliers from './ActiveExperts';

const Suppliers = () => (
  <div>
    <ActiveSuppliers />
    {/* <Pending /> */}
  </div>
);

export default Suppliers;
